export default "skymp5-front/7745bba7f91240599bed82f1466cfcd7.gif";